import React, { useEffect, useRef } from "react";
import { Canvas, PencilBrush, Image, FabricImage, Point } from "fabric";
import { useSearchParams } from "react-router-dom";
import { useItem } from "../firebase/firebase";
import { Link } from '@mui/material';
import { useIsMobile } from "../device/useIsMobile";

// gce_physics
// 00rLTkqulmYPxs6ubXy7
// http://localhost:3000/whiteboard?coll=gce_physics&id=00rLTkqulmYPxs6ubXy7

export const Scribble = () => {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const fabricRef = useRef<Canvas>(null);

    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const coll = searchParams.get("coll");
    const item = useItem(coll ? `${coll}_item` : "", id ?? "");
    const isMobile = useIsMobile();

    useEffect(() => {
        if (!fabricRef.current && canvasRef.current) {
            const canvas = new Canvas(canvasRef.current, {
                backgroundColor: "#fff",
                willReadFrequently: true,
            });
            canvas.setDimensions({ width: 1000, height: 1000 });
            fabricRef.current = canvas;

            canvas.freeDrawingBrush = new PencilBrush(canvas);
            canvas.isDrawingMode = true;
            canvas.freeDrawingBrush.width = 3;
            canvas.freeDrawingBrush.color = "#ff0000";
            canvas.freeDrawingBrush.shadow = null;

            if (isMobile) {
                (canvas.freeDrawingBrush as PencilBrush).decimate = 3;
                canvas.on("path:created", () => {
                    canvas.requestRenderAll(); // only re-render at end
                });
                canvas.renderOnAddRemove = false;
            }
        }

        if (fabricRef.current && item) {
            let promises = item.qp_img_urls.map(u => FabricImage.fromURL(u));
            Promise.all(promises)
                .then((images) => {
                    let y = 0;
                    let maxWidth = Math.max(...images.map(i => i.width));
                    for (let image of images) {
                        image.setXY(new Point(0, y));
                        (fabricRef.current as Canvas).add(image);
                        image.lockMovementX = true;
                        image.lockMovementY = true;
                        y += image.height;
                    }
                    (fabricRef.current as Canvas).setDimensions({ width: maxWidth, height: y + 1000 });
                })
        }
    }, [canvasRef, item]);

    return (
        <div style={{ textAlign: "center" }}>
            <canvas ref={canvasRef} />
            <Link
                href={item?.ms_pdf_url}
                underline="none"
                sx={{
                    position: 'fixed',
                    bottom: 20,
                    right: 120,
                    bgcolor: 'primary.main',
                    color: 'white',
                    px: 2,
                    py: 1,
                    borderRadius: 1,
                    boxShadow: 2,
                    fontWeight: 500,
                    fontSize: 18,
                    '&:hover': {
                        bgcolor: 'primary.dark',
                        textDecoration: 'none',
                    },
                }}
                target="_blank"
            >
                Show Solutions
            </Link>
        </div>
    );
}
